import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "title", "list"]
  toggleHidden() {
    this.formTarget.classList.toggle('hidden')
    this.titleTarget.classList.toggle('hidden')
  }
}
